import { keyBy } from 'lodash';
import { Channel, IChannelFromBE } from 'messaging/types/messages';
import { sortChannelsByLastActivity } from '.';
import { ChannelsMap } from 'messaging/types/redux/messagingState';

export default function generateChannelsMap(channels?: IChannelFromBE[]) {
    if (!channels) {
        return {};
    }

    return keyBy(sortChannelsByLastActivity(channels), 'channelId');
}

const generateChannel = (channel: IChannelFromBE): Channel => {
    return {
        id: channel.channelId,
        name: channel.channelType === 'service_request' ? channel.serviceRequestData?.title : '',
        messages: [],
        lastMessage: channel.lastMessage || '',
        lastMessageTimestamp: Number(channel.lastActivity),
        hasUnread: false,
        viewed: Number(channel.lastActivity),
        isLastMessageWithCallback: false,
    };
};

export const generateChannelsFromMap = (
    channelsMap: ChannelsMap,
    existingChannels: Record<string, Channel> = {},
): Record<string, Channel> =>
    Object.entries(channelsMap as { [id: string]: IChannelFromBE }).reduce((acc, [id, channel]) => {
        const generated = generateChannel(channel);
        const existing = existingChannels[id];

        return {
            ...acc,
            [id]: existing ? { ...generated, messages: existing.messages } : generated,
        };
    }, {} as Record<string, Channel>);
